import 'twin.macro'

import React, { FC } from 'react'
import tw, { TwStyle } from 'twin.macro'

type CaptionProps = {
  children: React.ReactNode
  variant?: 'bold' | 'regular'
  twStyle?: TwStyle
}
const textVariants = {
  bold: tw`font-bold`,
  regular: tw`font-normal`
} as { bold: TwStyle; regular: TwStyle }

const styles = {
  text: ({ variant = 'regular', twStyle }: { variant?: 'bold' | 'regular'; twStyle?: TwStyle }) => [
    tw`text-s12`,
    textVariants[variant],
    twStyle
  ]
}

export const Caption: FC<CaptionProps> = ({ children, variant, twStyle }) => {
  return <span css={styles.text({ variant, twStyle })}>{children}</span>
}
export default Caption
